export default __webpack_public_path__ + "static/media/home_thumb_LT_.9b03ff75.png";